<sub-header [isModal]="true" [windowHash]=windowHash [includeContextHelp]="false"></sub-header>
<p-scrollPanel [style]="{width: '100%', height: '80vh'}" styleClass="custombar1" *ngIf="isLoaded()">
  <div class="container-fluid m-b-lg" *ngIf="isLoaded()">
    <div class="row m-b-lg">
      <div class="col-12 ">
        <div class="titleElement"> {{'General.protocolo'|translate}} </div>
      </div>
      <div class="form-group col-6 mt-2">
        <label for="id">{{ 'General.identifier' | translate }}</label>
        <div class="p-inputgroup ">
          <input id="title" autofocus [(ngModel)]="this.protocol.identifier"
            class="plForm-element NOEDITABLE p-inputtext form-control" NOEDITABLE name="id" disabled="true" />
        </div>
      </div>
      <div class="form-group col-6 ">
        <label for="id">{{ 'General.description' | translate }}</label>
        <div class="p-inputgroup ">
          <input id="title" autofocus [(ngModel)]="this.protocol.description"
            class="plForm-element NOEDITABLE p-inputtext form-control" NOEDITABLE name="id" disabled="true" />
        </div>
      </div>
      <div class="col-12 ">
        <div class="titleElement"> {{'ControlPanel.protocols.actions.evaluate.title'|translate}} </div>
      </div>
      <form autocomplete="off">
        <div class="col-12 mt-2">
          <div class="col-12 alert alert-info"><i class="fa fa-1-5x fa-info-circle mr-2" aria-hidden="true"></i> {{
            'ControlPanel.protocols.actions.evaluate.info' | translate }}</div>
        </div>
        <div class="form-group col-4 ">
          <label for="title">{{ 'General.project' | translate }}</label>
          <div class="p-inputgroup ">
            <input id="title" autofocus [(ngModel)]="this.propuestaId"
              class="plForm-element EDITABLE p-inputtext form-control" NOEDITABLE name="title" />
          </div>
        </div>
        <div *ngIf="this.result" class="col-12">
          <div class="titleElement "> Resultado </div>
          <p-table [value]="this.result?.dto?.protocolProfiles">
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td [attr.colspan]="2"> No hay parámetros asociados a este WS </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="header">
              <tr>
                <th>Perfil</th>
                <th>Usuario</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
              <tr>
                <td>{{item.profile.description+'['+item.profile.identifier+']'}} </td>
                <td>{{item.profileRoleDescription+': '+ item.inbox.description+'['+item.inbox.identifier+']'}}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </form>
    </div>
  </div>
</p-scrollPanel>